import { InjectionToken } from '@angular/core';
import { StaticDialogData } from './ic-overlay.config';
import { StaticDialogRef } from './ic-overlay-ref';

export const STATIC_DIALOG_DATA = new InjectionToken<StaticDialogData>('STATIC_DIALOG_DATA');

export const STATIC_DIALOG_REF = new InjectionToken<StaticDialogRef<unknown>>('STATIC_DIALOG_REF');